import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';

import { ShClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { NavigationLinkDirective } from '../../directives/navigation-link/navigation-link.directive';
import { ShIconModule } from '../icon/icon.module';
import { ShBaseActionItemComponent } from './_base-action-item.component';
import { ActionItem } from './entities/action-item.entity';

@Component({
    standalone: true,
    selector: 'sh-droppanel-item',
    templateUrl: './action-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShIconModule, NavigationLinkDirective, ShClickOutsideDirective]
})
export class ShDroppanelItemComponent extends ShBaseActionItemComponent {
    @Input() focusIndex: number = -1;

    @Output() hovered: EventEmitter<MouseEvent> = new EventEmitter();

    protected getClassNames(item: ActionItem, childComponentClasses: string[]): string {
        let classNames: string[] = ['sh-droppanel__list-action'];

        if (item.icon) {
            classNames = [...classNames, 'sh-icon-button'];
        }

        if (item.disabled) {
            classNames = [...classNames, '-sh-disabled'];
        }

        return classNames.join(' ');
    }

    protected getLabelClassNames(): string {
        const classNames: string[] = ['sh-droppanel__list-action__label'];
        return classNames.join(' ');
    }

    onHover(event: MouseEvent): void {
        this.hovered.emit(event);
    }
}
